module.exports = __webpack_public_path__ + "img/status.a43ac744.png";